<div class="modal-header">
  <h5 class="modal-title">{{data.title}}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss('Close')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <p>{{data.description}}</p>
</div>
<div class="modal-footer gap-2">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel')">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="deleteCategory(data.id)">Delete</button>
</div>
